import { useState } from "react";
import usePersistantState from "./usePersistantState";

export default function useFormFields(init,id=`textArea${0}`) {
    const [textarea , setTextarea] = usePersistantState(id,init);
    const handleChange = (e) => {
        setTextarea(e.target.value);
    };
    return { textarea, handleChange };
}
